@let heading = headingField();
<section
  class="steps row d-flex justify-content-center"
  [ngClass]="'steps--theme-' + theme()"
>
  <div class="col-lg-8">
    <h2 *scText="heading"></h2>
    <ul class="list-unstyled list-no-default-spacing">
      @for (step of steps(); track step.explanation) {
        <li class="step-by-step" wlAutomationId="single-step">
          <div class="steps-line">
            <div class="step-by-step-card">
              <div class="step-by-step-icon">
                <crnt-icon
                  class="link-list--link-icon"
                  size="large"
                  [icon]="step.icon"
                  aria-hidden="true"
                />
              </div>
              <div class="step-by-step-content">
                <div>
                  <wl-rich-text-wrapper [field]="step.explanation">
                    <div></div>
                  </wl-rich-text-wrapper>
                </div>
              </div>
            </div>
          </div>
        </li>
      }
    </ul>
    @if (showButton() || isEditorActive()) {
      <div class="cta">
        <crnt-button-alt
          variant="secondary"
          [inverted]="isButtonInverted()"
          wlTrackLink
          [trackLinkInfo]="{
            rendering: { componentName: 'StepsComponent' },
            field: button()?.value?.text || '',
            eventType: 'button-click',
            type: 'button',
          }"
        >
          <a *wlGenericLink="button()"></a>
        </crnt-button-alt>
      </div>
    }
  </div>
</section>
